import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import {
  DepositWithrawData,
  DepositWithrawDataArray,
} from "../Utils/constants";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty,toLower } from "lodash";
import { useNavigate } from "react-router-dom";
import Jili from "../assets/imagesNew/jilii.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
const GameSlider = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: false,
    arrows: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 3,
        },
      },
    ],
  };
  const ref = useRef();
  const [data, setData] = useState({});
  const [getHotData, setHotData] = useState({});
  const [activeClass, SetActiveClass] = useState("");
  const navigate = useNavigate();
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const launchEGTCasino = useContextSelector(AuthContext, (ctx) => ctx.launchEGTCasino);
  const launchCasino = useContextSelector(AuthContext, (ctx) => ctx.launchCasino);
  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);
  const withoutLogin = useContextSelector(AuthContext, (ctx) => ctx.withoutLogin);
  const setShowDownloadBar = useContextSelector(AuthContext, (ctx) => ctx.setShowDownloadBar);
  const downloadBar = useContextSelector(AuthContext, (ctx) => ctx.downloadBar);
  const [key, setKey] = useState("hotgame");
  const [slideClass, setSlideClass] = useState("slide-left");

  useEffect(() => {
    setData(
      DepositWithrawDataArray?.find((res) => {
        {
          return res?.key == "hotgame";
        }
      })
    );

    window.addEventListener('scroll', () => {
      if(window.scrollY > 180){
       
        SetActiveClass('gamefixed');
      }else{
        SetActiveClass('');
      }
      
   });

  }, []);

  const setFunc = (type) => {
    setSlideClass("");
    setData(
      DepositWithrawDataArray?.find((res) => {
        {
          return res?.key == type;
        }
      })
    );
    setKey(type);
    setTimeout(() => {
      setSlideClass("slide-left");
  }, 10);
    
  };

  return (
    <div className="home-tabing-slider">
      <div  className={downloadBar?"payment-sec hide-scrollbar"+ activeClass:"payment-sec hide-scrollbar fixed-bar-height "+ activeClass} >
        {DepositWithrawData?.map((item) => {
          return (
            <div
              onClick={() => {
                
                  let gameType=toLower(item?.type);
                        let gameSubType=item?.subCategory?item?.subCategory:"";
                            navigate("/casino?header="+gameType+"&subCasino="+gameSubType)
                
              }}
              key={item?.type}
              className={`payment-box ${key == item?.type ? "active" : ""}`}
            >
             <svg className="am-icon am-icon-nav-hot_0b8ae9aa am-icon-md game-menu-icon"><use xlinkHref={item?.icons}></use></svg>
              
                 
              <span>{lang == "bn" ? item?.titlebn : item?.title}</span>
            </div>
          );
        })}
      </div>
      {/* {slideclassName=="slide-left" &&
      <div className="main-slider-div">
        <div className="main-slider-inner-div ">
          <div>
            <h5>{lang == "bn" ? data?.titlebn : data?.title}</h5>
          </div>
        
          <ul className={slideClass}>
            { data?.array?.map((res) => {
              return (
                <li> 
                  <div
                     onClick={() => {
                      if (!isEmpty(user)) {
                        if (res?.gameTypeCheck == "sports") {
                          window.open(res?.link, "_self");
                          } 
                       else if (data?.key == "sports") {
                        
                          
                              launchCasino({
                                platForm: res?.platForm,
                                gameType: res?.gameType,
                                casinoType: res?.casinoType,
                                isLobbyTrue:res?.isLobbyTrue
                              });
                            
                        } 
                        else if(res?.gameTypeCheck == "platForm") {
                          launchCasino({
                            platForm: res?.platForm,
                            gameType: res?.gameType,
                            casinoType: res?.casinoType,
                            isLobbyTrue:res?.isLobbyTrue
                          });
                        }
                       
                        else if(data?.key == "hotgame"){
                          launchCasino({
                            platForm: res?.platForm,
                            gameType: res?.gameType,
                            casinoType: res?.casinoType,
                          });
                        } else{
                          if (!isEmpty(user)) {
                            let subCategory=res?.platForm=="EVOLUTION"?"EVO":res?.platForm=="SEXYBCRT"?"SEXY":res?.platForm;
                            navigate("/casino?header="+toLower(res?.key)+"&subCasino="+subCategory)
                            
                          } else {
                            navigate("/login");
                          }
                        }
                      } else {
                       navigate("/login");
                      }
                    }}
                  >{
                    res?.image &&
                    <span>
                      <LazyLoadImage
                        effect="opacity"
                        alt={res?.img}
                        src={res?.image}
                      />
                    </span>
                  }
                    
                    <p>{res?.title}</p>
                  </div>
                </li>
              );
            })}
             
          </ul>
        </div>
      </div>} */}
    </div>
  );
};

export default GameSlider;
